import React, { useEffect, useState, useRef } from "react";
import logo from "../../assets/logo.png";
import bgVideo from "../../assets/finance-bg.mp4";
import AOS from "aos";
import "aos/dist/aos.css";
import Footer from "../../components/Footer/Footer";
import { MdEco, MdRecycling, MdScience, MdEmail, MdLocationOn, MdCampaign } from "react-icons/md";
import { FaTree, FaTint, FaGlobe, FaGraduationCap, FaSeedling, FaSchool, FaHandshake, FaSearch, FaChild } from "react-icons/fa";
import { WiThermometer } from "react-icons/wi";
import { GiBroom, GiButterfly, GiWaterDrop } from "react-icons/gi";
import { BsSunFill } from "react-icons/bs";
import { RiLeafLine, RiGovernmentLine } from "react-icons/ri";

/* ============================================================
   GLOBAL STYLES
   ============================================================ */
const GlobalStyles = () => (
  <style>{`
    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    body { font-family: 'DM Sans', sans-serif; background: #f0f7f0; color: #0e1a0e; overflow-x: hidden; }
    .syne { font-family: 'Syne', sans-serif; }
    .playfair { font-family: 'Playfair Display', serif; }

    .ripple-span {
      position: absolute; border-radius: 50%; transform: scale(0);
      animation: rippleAnim 650ms linear; background: rgba(255,255,255,0.35);
      pointer-events: none;
    }
    @keyframes rippleAnim { to { transform: scale(4); opacity: 0; } }
    @keyframes loaderSpin { to { transform: rotate(360deg); } }
    .loader-ring {
      width: 52px; height: 52px; border-radius: 50%;
      border: 3px solid rgba(34,197,94,0.2);
      border-top-color: #22c55e;
      animation: loaderSpin 0.8s linear infinite;
    }
    @keyframes heroFadeUp   { from { opacity:0; transform:translateY(40px); } to { opacity:1; transform:translateY(0); } }
    @keyframes heroScale    { from { opacity:0; transform:scale(0.85); } to { opacity:1; transform:scale(1); } }
    @keyframes floatY       { 0%,100% { transform:translateY(0); } 50% { transform:translateY(-14px); } }
    @keyframes orbPulse     { 0%,100% { transform:scale(1) translate(0,0); } 33% { transform:scale(1.08) translate(6px,-8px); } 66% { transform:scale(0.94) translate(-4px,6px); } }
    @keyframes countUp      { from { opacity:0; transform:translateY(8px); } to { opacity:1; transform:translateY(0); } }
    @keyframes shine        { 0% { left:-100%; } 100% { left:200%; } }
    @keyframes spin         { to { transform:rotate(360deg); } }
    @keyframes navSlideDown { from { transform:translateY(-100%); opacity:0; } to { transform:translateY(0); opacity:1; } }
    @keyframes leafSway     { 0%,100% { transform:rotate(-4deg) translateY(0); } 50% { transform:rotate(4deg) translateY(-8px); } }
    @keyframes pulse        { 0%,100% { opacity:1; } 50% { opacity:0.6; } }
    @keyframes cardIn       { from { opacity:0; transform:translateY(24px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }
    @keyframes slideRight   { from { width: 0; } to { width: 100%; } }
    @keyframes fadeSlideUp  { from { opacity:0; transform:translateY(30px); } to { opacity:1; transform:translateY(0); } }

    .hover-lift { transition: transform 0.3s cubic-bezier(0.34,1.56,0.64,1), box-shadow 0.3s ease; }
    .hover-lift:hover { transform: translateY(-6px); }

    .gradient-text-green {
      background: linear-gradient(135deg, #22c55e 0%, #4ade80 50%, #86efac 100%);
      -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;
    }

    ::-webkit-scrollbar { width: 6px; }
    ::-webkit-scrollbar-track { background: #f0f7f0; }
    ::-webkit-scrollbar-thumb { background: #22c55e; border-radius: 3px; }

    .btn { position:relative; overflow:hidden; cursor:pointer; border:none; font-family:'DM Sans',sans-serif; font-weight:500; transition:all 0.25s ease; }
    .btn:active { transform:scale(0.97); }

    .grid-pattern-green {
      background-image: linear-gradient(rgba(34,197,94,0.06) 1px, transparent 1px),
                        linear-gradient(90deg, rgba(34,197,94,0.06) 1px, transparent 1px);
      background-size: 48px 48px;
    }

    /* NEW: dot pattern */
    .dot-pattern {
      background-image: radial-gradient(circle, rgba(34,197,94,0.18) 1px, transparent 1px);
      background-size: 28px 28px;
    }

    /* NEW: diagonal stripe */
    .stripe-bg {
      background-image: repeating-linear-gradient(
        -45deg,
        transparent,
        transparent 8px,
        rgba(34,197,94,0.04) 8px,
        rgba(34,197,94,0.04) 16px
      );
    }

    /* NEW: section divider wave SVG approach */
    .wave-divider { display: block; width: 100%; overflow: hidden; line-height: 0; }

    /* Tab underline */
    .tab-underline { position: relative; }
    .tab-underline::after {
      content: ''; position: absolute; bottom: -3px; left: 0;
      height: 2px; background: #22c55e;
      width: 0; transition: width 0.35s ease;
    }
    .tab-underline.active::after { width: 100%; }

    /* Domain card hover */
    .domain-card { transition: all 0.35s cubic-bezier(0.34,1.2,0.64,1); cursor: default; }
    .domain-card:hover { transform: translateY(-8px) scale(1.015); }

    /* Testimonial hover */
    .testi-card { transition: all 0.3s ease; }
    .testi-card:hover { transform: translateY(-5px); }

    /* FAQ item */
    .faq-item { transition: background 0.25s ease; }
    .faq-item:hover { background: #f7fdf7 !important; }

    @media (min-width: 768px) { .hamburger { display: none !important; } }
    @media (max-width: 767px) { .desktop-links, .desktop-btns { display: none !important; } }

    @media (max-width: 640px) {
      .mission-grid { grid-template-columns: 1fr !important; }
      .actions-grid { grid-template-columns: 1fr !important; }
    }
  `}</style>
);

/* ============================================================
   PAGE LOADER
   ============================================================ */
const PageLoader = ({ loading }) => {
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    if (!loading) {
      const t = setTimeout(() => setVisible(false), 600);
      return () => clearTimeout(t);
    }
  }, [loading]);
  if (!visible) return null;
  return (
    <div style={{
      position: 'fixed', inset: 0, zIndex: 9999,
      background: '#040d04',
      display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.25rem',
      transition: 'opacity 0.6s ease',
      opacity: loading ? 1 : 0,
    }}>
      <img src={logo} alt="Logo" style={{ width: 48, height: 48, objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
      <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: 13, fontFamily: 'DM Sans, sans-serif', letterSpacing: '0.1em' }}>
        TUMAINI LETU
      </p>
    </div>
  );
};

/* ============================================================
   RIPPLE BUTTON
   ============================================================ */
const RippleButton = ({ children, style = {}, className = '', onClick }) => {
  const handleClick = (e) => {
    const btn = e.currentTarget;
    const span = document.createElement('span');
    const sz = Math.max(btn.clientWidth, btn.clientHeight);
    const rect = btn.getBoundingClientRect();
    span.className = 'ripple-span';
    Object.assign(span.style, {
      width: sz + 'px', height: sz + 'px',
      left: e.clientX - rect.left - sz / 2 + 'px',
      top: e.clientY - rect.top - sz / 2 + 'px',
    });
    btn.querySelectorAll('.ripple-span').forEach(s => s.remove());
    btn.appendChild(span);
    onClick && onClick(e);
  };
  return (
    <button className={`btn ${className}`} style={style} onClick={handleClick}>
      {children}
    </button>
  );
};

/* ============================================================
   NAVBAR (unchanged)
   ============================================================ */
const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const links = ['Accueil', 'Environnement', 'Agriculture', 'Nutrition'];

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  useEffect(() => {
    const fn = () => { if (window.innerWidth >= 768) setMenuOpen(false); };
    window.addEventListener('resize', fn);
    return () => window.removeEventListener('resize', fn);
  }, []);

  return (
    <nav style={{
      position: 'fixed', top: 0, left: 0, width: '100%', zIndex: 100,
      transition: 'all 0.4s ease',
      background: scrolled ? 'rgba(240,247,240,0.92)' : 'transparent',
      backdropFilter: scrolled ? 'blur(20px)' : 'none',
      borderBottom: scrolled ? '1px solid rgba(34,197,94,0.12)' : '1px solid transparent',
      animation: 'navSlideDown 0.6s ease both',
    }}>
      <div style={{ maxWidth: 1140, margin: '0 auto', padding: '0 1.25rem', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <button onClick={() => window.location.href = '/'} style={{ display: 'flex', alignItems: 'center', gap: '0.65rem', background: 'none', border: 'none', cursor: 'pointer' }}>
          <img src={logo} alt="Logo" style={{ width: 30, height: 30, objectFit: 'contain', animation: 'pulse 1.5s infinite' }} />
          <span className="syne" style={{ fontWeight: 700, fontSize: 17, color: scrolled ? '#0e1a0e' : '#fff' }}>
            Tumaini Letu
          </span>
        </button>

        <div style={{ display: 'flex', gap: '2rem', alignItems: 'center' }} className="desktop-links">
          {links.map(l => (
            <button key={l} onClick={() => { if (l === 'Accueil') window.location.href = '/'; if (l === 'Agriculture') window.location.href = '/agriculture';; if (l === 'Nutrition') window.location.href = '/nutrition'; }} style={{
              fontSize: 14, fontWeight: l === 'Environnement' ? 600 : 400,
              color: l === 'Environnement' ? '#22c55e' : (scrolled ? '#2d4a2d' : 'rgba(255,255,255,0.8)'),
              background: 'none', border: 'none', cursor: 'pointer',
              transition: 'color 0.2s', fontFamily: 'DM Sans, sans-serif',
            }}
              onMouseEnter={e => e.target.style.color = '#22c55e'}
              onMouseLeave={e => e.target.style.color = l === 'Environnement' ? '#22c55e' : (scrolled ? '#2d4a2d' : 'rgba(255,255,255,0.8)')}
            >{l}</button>
          ))}
        </div>

        <div style={{ display: 'flex', gap: '0.6rem', alignItems: 'center' }}>
          <div style={{ display: 'flex', gap: '0.6rem' }} className="desktop-btns">
            <RippleButton style={{ padding: '0.5rem 1.1rem', borderRadius: 10, background: '#22c55e', color: '#fff', fontSize: 13, fontWeight: 500 }}>Se connecter</RippleButton>
            <RippleButton style={{ padding: '0.5rem 1.1rem', borderRadius: 10, background: 'transparent', color: scrolled ? '#22c55e' : '#fff', border: `1.5px solid ${scrolled ? '#22c55e' : 'rgba(255,255,255,0.5)'}`, fontSize: 13, fontWeight: 500 }}>S'inscrire</RippleButton>
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="hamburger" style={{ background: 'none', border: 'none', cursor: 'pointer', padding: '6px', display: 'flex', flexDirection: 'column', gap: 5 }}>
            {[0, 1, 2].map(i => (
              <span key={i} style={{
                display: 'block', width: 22, height: 2,
                background: scrolled ? '#0e1a0e' : '#fff',
                borderRadius: 2, transition: 'all 0.3s ease',
                transform: menuOpen ? (i === 0 ? 'rotate(45deg) translate(5px,5px)' : i === 2 ? 'rotate(-45deg) translate(5px,-5px)' : 'scaleX(0)') : 'none',
                opacity: menuOpen && i === 1 ? 0 : 1,
              }} />
            ))}
          </button>
        </div>
      </div>

      <div style={{
        overflow: 'hidden', background: 'rgba(240,247,240,0.97)', backdropFilter: 'blur(20px)',
        maxHeight: menuOpen ? 400 : 0, transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)',
        borderTop: menuOpen ? '1px solid rgba(34,197,94,0.1)' : 'none',
      }}>
        <div style={{ padding: '1rem 1.25rem', display: 'flex', flexDirection: 'column', gap: '0.1rem' }}>
          {links.map(l => (
            <a key={l} href="#" onClick={() => setMenuOpen(false)} style={{
              display: 'block', padding: '0.75rem 0',
              borderBottom: '1px solid rgba(34,197,94,0.08)',
              color: l === 'Environnement' ? '#22c55e' : '#2d4a2d',
              textDecoration: 'none', fontSize: 15,
              fontWeight: l === 'Environnement' ? 600 : 400,
              fontFamily: 'DM Sans, sans-serif',
            }}>{l}</a>
          ))}
          <div style={{ display: 'flex', gap: '0.75rem', paddingTop: '0.75rem' }}>
            <RippleButton style={{ flex: 1, padding: '0.65rem', borderRadius: 10, background: '#22c55e', color: '#fff', fontSize: 14, fontWeight: 500 }}>Se connecter</RippleButton>
            <RippleButton style={{ flex: 1, padding: '0.65rem', borderRadius: 10, background: 'transparent', color: '#22c55e', border: '1.5px solid #22c55e', fontSize: 14, fontWeight: 500 }}>S'inscrire</RippleButton>
          </div>
        </div>
      </div>
    </nav>
  );
};

/* ============================================================
   STAT CARD (unchanged – used in hero)
   ============================================================ */
const StatCard = ({ label, value, sub, accentColor, iconChar: IconComponent, delay }) => (
  <div style={{
    position: 'relative', overflow: 'hidden',
    borderRadius: 20,
    background: 'rgba(255,255,255,0.06)',
    border: '1px solid rgba(255,255,255,0.12)',
    backdropFilter: 'blur(20px)',
    padding: '1.4rem 1.5rem',
    cursor: 'default',
    animation: `cardIn 0.7s cubic-bezier(0.34,1.3,0.64,1) ${delay}s both`,
    transition: 'transform 0.3s cubic-bezier(0.34,1.56,0.64,1), border-color 0.3s',
  }}
    onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px) scale(1.02)'; e.currentTarget.style.borderColor = accentColor + '60'; }}
    onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0) scale(1)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.12)'; }}
  >
    <div style={{ position: 'absolute', top: -32, right: -32, width: 100, height: 100, borderRadius: '50%', background: accentColor, opacity: 0.18, filter: 'blur(28px)', pointerEvents: 'none' }} />
    <div style={{ position: 'absolute', top: 14, right: 16, opacity: 0.15, lineHeight: 1 }}>{IconComponent && <IconComponent size={28} color={accentColor} />}</div>
    <div style={{ position: 'relative', zIndex: 1 }}>
      <p style={{ fontSize: 10, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.45)', marginBottom: '0.65rem', fontFamily: 'Syne, sans-serif' }}>{label}</p>
      <h2 style={{ fontSize: 26, fontWeight: 700, color: '#fff', fontFamily: 'Syne, sans-serif', marginBottom: '0.5rem', animation: `countUp 0.5s ease ${delay + 0.2}s both` }}>{value}</h2>
      <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.35)' }}>{sub}</p>
    </div>
  </div>
);

/* ============================================================
   HERO SECTION (unchanged)
   ============================================================ */
const Hero = ({ video }) => {
  const videoRef = useRef(null);
  useEffect(() => {
    const fn = () => {
      if (videoRef.current) videoRef.current.style.transform = `scale(${1 + window.scrollY / 5000})`;
    };
    window.addEventListener('scroll', fn, { passive: true });
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const stats = [
    { label: 'Arbres plantés', value: '23', sub: 'Depuis la création', accentColor: '#22c55e', iconChar: FaTree, delay: 0.5 },
    { label: 'Zones assainies', value: '13', sub: 'Zones d\'intervention', accentColor: '#06b6d4', iconChar: GiWaterDrop, delay: 0.65 },
    { label: 'Personnes sensibilisées', value: '350', sub: 'Programme éducatif', accentColor: '#f59e0b', iconChar: FaGlobe, delay: 0.8 },
  ];

  return (
    <header style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden', color: '#fff', display: 'flex', flexDirection: 'column' }}>
      <video ref={videoRef} autoPlay loop muted playsInline style={{
        position: 'absolute', inset: 0, width: '100%', height: '100%',
        objectFit: 'cover', transition: 'transform 0.1s linear',
      }}>
        <source src={video} type="video/mp4" />
      </video>
      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(160deg, rgba(4,20,4,0.92) 0%, rgba(4,20,4,0.78) 50%, rgba(10,40,10,0.75) 100%)' }} />
      {[
        { size: 500, color: '#22c55e', top: '-15%', right: '-10%', dur: '12s', opacity: 0.1 },
        { size: 400, color: '#06b6d4', bottom: '-10%', left: '-8%', dur: '16s', opacity: 0.08 },
        { size: 280, color: '#4ade80', top: '30%', left: '15%', dur: '9s', opacity: 0.06 },
      ].map((o, i) => (
        <div key={i} style={{
          position: 'absolute', width: o.size, height: o.size, borderRadius: '50%',
          background: o.color, top: o.top, bottom: o.bottom, left: o.left, right: o.right,
          filter: `blur(${o.size / 2.5}px)`, opacity: o.opacity, pointerEvents: 'none',
          animation: `orbPulse ${o.dur} ease-in-out infinite ${i * 2}s`,
        }} />
      ))}
      <div className="grid-pattern-green" style={{ position: 'absolute', inset: 0, opacity: 0.4, pointerEvents: 'none' }} />
      <div style={{
        position: 'relative', zIndex: 2,
        flex: 1, display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '7rem 1.5rem 3.5rem',
        textAlign: 'center',
      }}>
        <div style={{
          display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
          padding: '0.4rem 1rem', borderRadius: 99,
          background: 'rgba(34,197,94,0.12)', border: '1px solid rgba(34,197,94,0.3)',
          marginBottom: '1.5rem',
          animation: 'heroFadeUp 0.6s ease 0.1s both',
        }}>
          <span style={{ width: 7, height: 7, borderRadius: '50%', background: '#22c55e', display: 'inline-block', animation: 'spin 3s linear infinite' }} />
          <span style={{ fontSize: 12, fontWeight: 500, color: 'rgba(34,197,94,0.9)', letterSpacing: '0.1em', fontFamily: 'Syne, sans-serif' }}>
            ESPACE ENVIRONNEMENTAL SÉCURISÉ
          </span>
        </div>
        <div style={{ animation: 'heroFadeUp 0.7s ease 0.2s both', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={logo} alt="Logo" style={{ width: 160, height: 140, objectFit: 'contain', animation: 'pulse 1.5s infinite', marginBottom: '1.2rem' }} />
          <h1 className="syne" style={{ fontSize: 'clamp(1rem, 7vw, 5.6rem)', fontWeight: 'bolder', lineHeight: 2.08, letterSpacing: '-0.02em', marginBottom: '0.85rem' }}>
            <span className="gradient-text-green">Environnement</span>
          </h1>
          <p style={{ fontSize: 'clamp(15px, 2vw, 18px)', color: 'rgba(255,255,255,0.55)', maxWidth: 520, lineHeight: 1.65, fontWeight: 300 }}>
            TUMAINI LETU ASBL s'engage pour la protection de l'écologie, la conservation de la biodiversité et un avenir durable pour tous.
          </p>
        </div>
        <div style={{ width: 48, height: 2, background: 'linear-gradient(90deg, transparent, #22c55e, transparent)', margin: '2rem auto', animation: 'heroFadeUp 0.7s ease 0.35s both' }} />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 14, width: '100%', maxWidth: 700, marginBottom: '2rem' }}>
          {stats.map(s => <StatCard key={s.label} {...s} />)}
        </div>
        <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '0.75rem', animation: 'heroFadeUp 0.7s ease 1s both' }}>
          {[
            { label: 'Rejoindre la cause', bg: '#22c55e', color: '#fff', border: 'none' },
            { label: 'Nos actions', bg: 'rgba(255,255,255,0.07)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' },
            { label: 'Faire un don', bg: '#fff', color: '#22c55e', border: 'none' },
            { label: 'Nous contacter', bg: 'rgba(255,255,255,0.07)', color: '#fff', border: '1px solid rgba(255,255,255,0.25)' },
          ].map(b => (
            <RippleButton key={b.label} style={{
              padding: '0.7rem 1.4rem', borderRadius: 12,
              background: b.bg, color: b.color, border: b.border,
              fontSize: 14, fontWeight: 500, fontFamily: 'DM Sans, sans-serif',
              backdropFilter: 'blur(10px)', transition: 'all 0.25s ease',
            }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-2px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
            >{b.label}</RippleButton>
          ))}
        </div>
        <div style={{ marginTop: '3rem', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.4rem', opacity: 0.35, animation: 'heroFadeUp 0.7s ease 1.2s both' }}>
          <span style={{ fontSize: 10, letterSpacing: '0.2em', fontFamily: 'Syne, sans-serif' }}>DÉFILER</span>
          <div style={{ width: 1, height: 36, background: 'rgba(255,255,255,0.4)', animation: 'floatY 2s ease-in-out infinite' }} />
        </div>
      </div>
    </header>
  );
};

/* ============================================================
   ── NEW DESIGN BEGINS HERE ──
   ============================================================ */

/* PULL QUOTE / INTRO STRIP */
const IntroStrip = () => (
  <section style={{
    background: '#1a3320',
    padding: '3rem 2rem',
    overflow: 'hidden',
    position: 'relative',
  }}>
    <div style={{
      position: 'absolute', inset: 0,
      backgroundImage: 'repeating-linear-gradient(-60deg, transparent, transparent 40px, rgba(255,255,255,0.015) 40px, rgba(255,255,255,0.015) 41px)',
      pointerEvents: 'none',
    }} />
    <div style={{
      maxWidth: 1140, margin: '0 auto',
      display: 'flex', flexWrap: 'wrap', alignItems: 'center',
      gap: '2rem', justifyContent: 'space-between',
    }}>
      <div style={{ flex: '1 1 300px' }}>
        <p className="playfair" style={{
          fontSize: 'clamp(1.4rem, 3vw, 2.2rem)',
          color: '#b6e9c2',
          lineHeight: 1.45,
          fontStyle: 'italic',
          fontWeight: 400,
        }}>
          "La terre ne nous appartient pas — nous l'empruntons à nos enfants."
        </p>
        <p style={{ marginTop: '1rem', fontSize: 13, color: 'rgba(255,255,255,0.35)', letterSpacing: '0.08em', fontFamily: 'Syne, sans-serif' }}>— TUMAINI LETU ASBL</p>
      </div>
      <div style={{ flex: '1 1 260px', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
        {[['23', 'Arbres plantés', FaTree], ['13', 'Zones assainies', GiWaterDrop], ['350', 'Sensibilisés', FaGlobe]].map(([n, l, IconComp]) => (
          <div key={l} style={{
            flex: '1 1 80px', textAlign: 'center',
            padding: '1.2rem 0.75rem',
            borderRadius: 14,
            background: 'rgba(255,255,255,0.05)',
            border: '1px solid rgba(255,255,255,0.08)',
          }}>
            <div style={{ marginBottom: '0.4rem' }}><IconComp size={20} color='#22c55e' /></div>
            <p className="syne" style={{ fontSize: 22, fontWeight: 800, color: '#4ade80' }}>{n}</p>
            <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.4)', marginTop: '0.2rem', lineHeight: 1.4 }}>{l}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* MISSION SECTION — editorial 2-col layout */
const MissionSection = ({ activeTab, setActiveTab }) => (
  <section style={{ background: '#fafdf8', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
    {/* giant ghost letter */}
    <div className="playfair" style={{
      position: 'absolute', top: -40, left: -20,
      fontSize: 'clamp(200px,25vw,360px)',
      fontWeight: 900, color: 'rgba(34,197,94,0.04)',
      lineHeight: 1, pointerEvents: 'none', userSelect: 'none',
      letterSpacing: '-0.05em',
    }}>M</div>

    <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
      {/* Editorial label */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '2.5rem' }}>
        <div style={{ width: 48, height: 3, background: '#22c55e', borderRadius: 2 }} />
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#22c55e', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Mission & Engagement</span>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '4rem', alignItems: 'start' }} className="mission-grid">
        {/* Left: big heading */}
        <div>
          <h2 className="playfair" style={{
            fontSize: 'clamp(2rem, 4vw, 3.2rem)',
            fontWeight: 900, lineHeight: 1.12,
            color: '#0e1a0e', marginBottom: '1.5rem',
            letterSpacing: '-0.02em',
          }}>
            Protéger la planète,<br />
            <span style={{ color: '#22c55e', fontStyle: 'italic' }}>ensemble.</span>
          </h2>
          <p style={{ fontSize: 15, color: '#4a6b4a', lineHeight: 1.85, marginBottom: '2rem' }}>
            TUMAINI LETU ASBL est l'un des acteurs à but non lucratif qui luttent pour la protection de l'écologie. Nos domaines d'action s'articulent autour de la conservation de la biodiversité, la lutte contre le changement climatique et l'éducation environnementale.
          </p>
          {/* Tab pills */}
          <div style={{ display: 'flex', gap: '0.5rem', marginBottom: '1.75rem' }}>
            {['mission', 'engagement'].map(tab => (
              <button key={tab} onClick={() => setActiveTab(tab)} style={{
                padding: '0.55rem 1.3rem', borderRadius: 99,
                border: activeTab === tab ? '1.5px solid #22c55e' : '1.5px solid rgba(34,197,94,0.2)',
                background: activeTab === tab ? '#22c55e' : 'transparent',
                color: activeTab === tab ? '#fff' : '#22c55e',
                fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 12,
                letterSpacing: '0.05em', textTransform: 'uppercase',
                cursor: 'pointer', transition: 'all 0.25s ease',
              }}>
                {tab === 'mission' ? 'Notre mission' : 'Notre engagement'}
              </button>
            ))}
          </div>

          {activeTab === 'mission' ? (
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: '0.8rem' }}>
              {[
                'Conservation de la biodiversité locale et régionale',
                'Lutte active contre le changement climatique',
                'Gestion responsable des déchets et de la pollution',
                'Éducation environnementale pour toutes les générations',
                'Actions concrètes de reboisement et d\'assainissement',
                'Plaidoyer et information des populations',
              ].map((item, i) => (
                <li key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem', fontSize: 14, color: '#2d4a2d', lineHeight: 1.7 }}>
                  <span style={{
                    width: 22, height: 22, borderRadius: 6, flexShrink: 0, marginTop: 1,
                    background: 'linear-gradient(135deg, #22c55e, #4ade80)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 10, color: '#fff', fontWeight: 800,
                  }}>✓</span>
                  {item}
                </li>
              ))}
            </ul>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1.1rem' }}>
              {[
                "Être un acteur de référence dans la protection de l'environnement dans le monde entier, en menant des actions mesurables et durables.",
                "Mobiliser les communautés locales autour de projets écologiques concrets pour préserver les ressources naturelles.",
                "Combattre le réchauffement climatique par des initiatives de reboisement, d'énergie propre et d'éducation écologique.",
              ].map((p, i) => (
                <p key={i} style={{ fontSize: 14, color: '#4a6b4a', lineHeight: 1.85, paddingLeft: '1rem', borderLeft: '3px solid #22c55e' }}>{p}</p>
              ))}
            </div>
          )}
        </div>

        {/* Right: stacked accent boxes */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          {[
            { num: '01', label: 'Écologie & Biodiversité', color: '#22c55e', bg: '#f0fdf4', Icon: MdEco },
            { num: '02', label: 'Changement Climatique', color: '#f59e0b', bg: '#fffbeb', Icon: BsSunFill },
            { num: '03', label: 'Éducation Verte', color: '#8b5cf6', bg: '#f5f3ff', Icon: FaGraduationCap },
            { num: '04', label: 'Gestion des Déchets', color: '#06b6d4', bg: '#f0fdff', Icon: MdRecycling },
          ].map(item => (
            <div key={item.num} className="domain-card" style={{
              display: 'flex', alignItems: 'center', gap: '1.25rem',
              padding: '1.25rem 1.5rem',
              borderRadius: 16,
              background: item.bg,
              border: `1px solid ${item.color}20`,
            }}>
              <div style={{
                width: 50, height: 50, borderRadius: 12, flexShrink: 0,
                background: item.color + '18',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: 22,
              }}>{item.Icon && <item.Icon size={20} color={item.color} />}</div>
              <div style={{ flex: 1 }}>
                <p style={{ fontSize: 10, color: item.color, fontWeight: 700, letterSpacing: '0.12em', fontFamily: 'Syne, sans-serif', marginBottom: '0.25rem' }}>AXED {item.num}</p>
                <p className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#0e1a0e' }}>{item.label}</p>
              </div>
              <div style={{ width: 28, height: 28, borderRadius: '50%', background: item.color + '15', display: 'flex', alignItems: 'center', justifyContent: 'center', color: item.color, fontSize: 14 }}>→</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

/* DOMAINS SECTION — editorial magazine grid */
const DomainsSection = () => {
  const domains = [
    { Icon: BsSunFill, color: '#f59e0b', title: 'Climat & Énergie', desc: 'Réduction des émissions de gaz à effet de serre et promotion des énergies renouvelables pour un futur décarboné.' },
    { Icon: MdEco, color: '#22c55e', title: 'Nature & Biodiversité', desc: 'Protection des écosystèmes menacés, lutte contre la déforestation et préservation des espèces.' },
    { Icon: MdRecycling, color: '#06b6d4', title: 'Pollution & Déchets', desc: 'Gestion des déchets plastiques, assainissement et protection des ressources en eau et des sols.' },
    { Icon: FaGraduationCap, color: '#8b5cf6', title: 'Éducation', desc: 'Formations et programmes d\'écologie pour impliquer la société civile et les jeunes.' },
    { Icon: GiWaterDrop, color: '#0ea5e9', title: 'Gestion de l\'eau', desc: 'Préservation des sources d\'eau, protection des rivières et consommation hydrique responsable.' },
    { Icon: FaSeedling, color: '#84cc16', title: 'Agriculture durable', desc: 'Pratiques agricoles respectueuses de l\'environnement et de l\'agroforesterie communautaire.' },
  ];

  return (
    <section style={{ background: '#0d1f0d', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      {/* Dot pattern overlay */}
      <div className="dot-pattern" style={{ position: 'absolute', inset: 0, opacity: 0.4, pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
        {/* Header row */}
        <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: '1.5rem', marginBottom: '3.5rem' }}>
          <div>
            <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#4ade80', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>— Domaines d'intervention</p>
            <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', color: '#fff', fontWeight: 900, lineHeight: 1.1 }}>
              Six axes<br /><span style={{ color: '#4ade80', fontStyle: 'italic' }}>stratégiques</span>
            </h2>
          </div>
          <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.4)', maxWidth: 320, lineHeight: 1.75 }}>
            Nos actions couvrent plusieurs axes pour une protection globale et efficace de l'environnement.
          </p>
        </div>

        {/* Domain grid */}
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1px', background: 'rgba(255,255,255,0.06)', borderRadius: 20, overflow: 'hidden' }}>
          {domains.map((d, i) => (
            <div key={d.title} className="domain-card" style={{
              padding: '2rem',
              background: '#0d1f0d',
              position: 'relative', overflow: 'hidden',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = d.color + '12'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#0d1f0d'; }}
            >
              <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: 2, background: d.color, opacity: 0.6 }} />
              <div style={{ marginBottom: '1rem' }}>{d.Icon && <d.Icon size={32} color={d.color} />}</div>
              <h3 className="syne" style={{ fontSize: 16, fontWeight: 700, color: '#fff', marginBottom: '0.6rem' }}>{d.title}</h3>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.75 }}>{d.desc}</p>
              <div style={{
                display: 'inline-flex', alignItems: 'center', gap: '0.4rem',
                marginTop: '1.25rem', fontSize: 12, color: d.color,
                fontFamily: 'Syne, sans-serif', fontWeight: 700, letterSpacing: '0.06em',
              }}>
                EN SAVOIR + <span>→</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* ACTIONS SECTION — horizontal scroll cards on mobile, asymmetric on desktop */
const ActionsSection = () => {
  const actions = [
    { num: '01', title: 'Reboisement', desc: 'Campagnes de plantation d\'arbres dans les zones déforestées pour restaurer les écosystèmes locaux.', color: '#22c55e', Icon: FaTree, tag: 'Écosystème' },
    { num: '02', title: 'Assainissement', desc: 'Opérations de nettoyage des quartiers, marchés et cours d\'eau pour réduire la pollution.', color: '#06b6d4', Icon: GiBroom, tag: 'Pollution' },
    { num: '03', title: 'Plaidoyer', desc: 'Actions de lobbying auprès des autorités pour renforcer les politiques environnementales locales.', color: '#f59e0b', Icon: MdCampaign, tag: 'Politique' },
    { num: '04', title: 'Formation', desc: 'Ateliers et séminaires pour former les communautés aux bonnes pratiques écologiques.', color: '#8b5cf6', Icon: FaGraduationCap, tag: 'Éducation' },
  ];

  return (
    <section style={{ background: '#fafdf8', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      {/* Stripe bg */}
      <div className="stripe-bg" style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.75rem' }}>
          <div style={{ width: 48, height: 3, background: '#22c55e', borderRadius: 2 }} />
          <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#22c55e', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Actions concrètes</span>
        </div>
        <h2 className="playfair" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 900, color: '#0e1a0e', lineHeight: 1.12, marginBottom: '3rem' }}>
          Ce que nous<br /><span style={{ fontStyle: 'italic', color: '#22c55e' }}>faisons</span>
        </h2>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '1.5rem' }} className="actions-grid">
          {actions.map((a, i) => (
            <div key={a.title} data-aos="fade-up" data-aos-delay={i * 80} style={{
              borderRadius: 20, overflow: 'hidden', position: 'relative',
              background: '#fff',
              border: '1px solid rgba(0,0,0,0.06)',
              boxShadow: '0 2px 20px rgba(0,0,0,0.04)',
              transition: 'transform 0.35s cubic-bezier(0.34,1.2,0.64,1), box-shadow 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-8px)'; e.currentTarget.style.boxShadow = `0 20px 40px ${a.color}18`; }}
              onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 20px rgba(0,0,0,0.04)'; }}
            >
              {/* Top color band */}
              <div style={{ height: 5, background: a.color }} />
              <div style={{ padding: '1.5rem' }}>
                {/* Number + tag row */}
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.25rem' }}>
                  <span className="syne" style={{ fontSize: 11, color: 'rgba(0,0,0,0.18)', fontWeight: 800, letterSpacing: '0.05em' }}>{a.num}</span>
                  <span style={{
                    fontSize: 10, fontWeight: 700, letterSpacing: '0.1em',
                    color: a.color, background: a.color + '15',
                    padding: '0.25rem 0.65rem', borderRadius: 99,
                    fontFamily: 'Syne, sans-serif', textTransform: 'uppercase',
                  }}>{a.tag}</span>
                </div>
                <div style={{ marginBottom: '1rem' }}>{a.Icon && <a.Icon size={36} color={a.color} />}</div>
                <h3 className="syne" style={{ fontSize: 18, fontWeight: 800, color: '#0e1a0e', marginBottom: '0.6rem' }}>{a.title}</h3>
                <p style={{ fontSize: 13, color: '#5a7a5a', lineHeight: 1.75 }}>{a.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* WHY JOIN — alternating feature rows */
const WhySection = () => {
  const reasons = [
    { Icon: BsSunFill, color: '#f97316', title: 'Urgence climatique', desc: 'La planète se réchauffe rapidement. Chaque action compte pour limiter les effets dévastateurs du changement climatique.' },
    { Icon: GiButterfly, color: '#22c55e', title: 'Biodiversité menacée', desc: 'Des milliers d\'espèces sont en danger. Protéger les écosystèmes, c\'est préserver l\'avenir de notre planète.' },
    { Icon: GiWaterDrop, color: '#06b6d4', title: 'Ressources en danger', desc: 'L\'eau potable et les sols fertiles se raréfient. Agir maintenant, c\'est garantir les ressources pour demain.' },
    { Icon: FaChild, color: '#8b5cf6', title: 'Générations futures', desc: 'Nos enfants méritent un monde sain. Chaque geste est un cadeau offert aux générations à venir.' },
    { Icon: FaHandshake, color: '#ec4899', title: 'Impact communautaire', desc: 'Un environnement sain améliore la santé, l\'économie et la qualité de vie de toute la communauté.' },
    { Icon: MdScience, color: '#f59e0b', title: 'Science & innovation', desc: 'Nous nous appuyons sur des données scientifiques pour concevoir des solutions efficaces et durables.' },
  ];

  return (
    <section style={{ background: '#0d1f0d', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      <div style={{ position: 'absolute', bottom: 0, right: 0, width: 500, height: 500, borderRadius: '50%', background: 'rgba(34,197,94,0.05)', filter: 'blur(120px)', pointerEvents: 'none' }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#4ade80', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Pourquoi s'engager</p>
          <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', color: '#fff', fontWeight: 900, lineHeight: 1.12 }}>
            Rejoindre notre<br /><span style={{ fontStyle: 'italic', color: '#4ade80' }}>cause</span>
          </h2>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
          {reasons.map((r, i) => (
            <div key={r.title} data-aos="fade-up" data-aos-delay={i * 60} style={{
              display: 'flex', gap: '1.25rem', alignItems: 'flex-start',
              padding: '1.5rem',
              borderRadius: 16,
              background: 'rgba(255,255,255,0.03)',
              border: '1px solid rgba(255,255,255,0.06)',
              transition: 'all 0.3s ease',
            }}
              onMouseEnter={e => { e.currentTarget.style.background = r.color + '0d'; e.currentTarget.style.borderColor = r.color + '30'; }}
              onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.03)'; e.currentTarget.style.borderColor = 'rgba(255,255,255,0.06)'; }}
            >
              <div style={{ width: 48, height: 48, borderRadius: 12, background: r.color + '18', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{r.Icon && <r.Icon size={22} color={r.color} />}</div>
              <div>
                <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#fff', marginBottom: '0.4rem' }}>{r.title}</h3>
                <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.4)', lineHeight: 1.75 }}>{r.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Big CTA */}
        <div data-aos="fade-up" style={{
          marginTop: '3rem', borderRadius: 24, overflow: 'hidden',
          background: 'linear-gradient(135deg, #16a34a 0%, #22c55e 60%, #4ade80 100%)',
          padding: 'clamp(2rem,4vw,3rem)',
          display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between',
          gap: '2rem', position: 'relative',
        }}>
          <div style={{ position: 'absolute', top: -60, right: -60, width: 240, height: 240, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', pointerEvents: 'none' }} />
          <div>
            <h3 className="playfair" style={{ fontSize: 'clamp(1.4rem, 3vw, 2.2rem)', fontWeight: 900, color: '#fff', lineHeight: 1.2, marginBottom: '0.5rem' }}>
              Un avenir vert et durable<br />pour tous.
            </h3>
            <p style={{ fontSize: 14, color: 'rgba(255,255,255,0.65)', maxWidth: 420, lineHeight: 1.7 }}>
              TUMAINI LETU place la nature au cœur de toutes ses actions pour une croissance inclusive et respectueuse de l'environnement.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
            <RippleButton
              style={{
                padding: '0.7rem 1.5rem',
                borderRadius: 12,
                background: '#fff',
                color: 'black',
                fontSize: 14,
                fontWeight: 600
              }}
              onClick={() => {
                window.location.href = "mailto:info@tumainiletu.com?subject=Demande%20d'adhésion";
              }}
            >
              Nous rejoindre
            </RippleButton>
            <RippleButton style={{ padding: '0.85rem 2rem', borderRadius: 12, background: 'rgba(0,0,0,0.15)', color: '#fff', border: '1px solid rgba(255,255,255,0.3)', fontSize: 14, fontWeight: 600 }}>En savoir plus</RippleButton>
          </div>
        </div>
      </div>
    </section>
  );
};

/* WHO IS INVOLVED — magazine feature cards */
const ActorsSection = () => (
  <section style={{ background: '#fafdf8', padding: '6rem 1.5rem', position: 'relative' }} data-aos="fade-up">
    <div style={{ maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '0.75rem' }}>
        <div style={{ width: 48, height: 3, background: '#22c55e', borderRadius: 2 }} />
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#22c55e', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Les acteurs</span>
      </div>
      <h2 className="playfair" style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', fontWeight: 900, color: '#0e1a0e', lineHeight: 1.1, marginBottom: '3rem' }}>
        Qui s'implique<br /><span style={{ fontStyle: 'italic', color: '#22c55e' }}>dans la cause ?</span>
      </h2>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1.5rem' }}>
        {[
          { Icon: FaSchool, color: '#22c55e', title: 'Écoles & Jeunes', desc: 'Clubs verts, programmes scolaires et brigades environnementales impliquant les nouvelles générations au cœur de la mission.' },
          { Icon: RiGovernmentLine, color: '#06b6d4', title: 'Autorités locales', desc: 'Collaboration institutionnelle pour intégrer l\'écologie dans les politiques publiques et la gouvernance environnementale.' },
          { Icon: FaHandshake, color: '#f59e0b', title: 'Communautés', desc: 'Participation active des communautés locales aux actions de terrain : nettoyage, reboisement et sensibilisation.' },
          { Icon: MdScience, color: '#8b5cf6', title: 'Chercheurs & Experts', desc: 'Scientifiques et experts environnementaux qui guident nos actions avec des données fiables et des solutions innovantes.' },
        ].map((a, i) => (
          <div key={a.title} data-aos="fade-up" data-aos-delay={i * 70} style={{
            borderRadius: 18, background: '#fff',
            border: '1px solid rgba(0,0,0,0.05)',
            boxShadow: '0 2px 16px rgba(0,0,0,0.04)',
            overflow: 'hidden',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-6px)'; e.currentTarget.style.boxShadow = `0 16px 32px ${a.color}20`; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 16px rgba(0,0,0,0.04)'; }}
          >
            <div style={{ height: 90, background: `linear-gradient(135deg, ${a.color}15, ${a.color}05)`, display: 'flex', alignItems: 'center', justifyContent: 'center', borderBottom: `3px solid ${a.color}30` }}>{a.Icon && <a.Icon size={38} color={a.color} />}</div>
            <div style={{ padding: '1.25rem 1.5rem' }}>
              <h3 className="syne" style={{ fontSize: 15, fontWeight: 700, color: '#0e1a0e', marginBottom: '0.5rem' }}>{a.title}</h3>
              <p style={{ fontSize: 13, color: '#5a7a5a', lineHeight: 1.75 }}>{a.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* TESTIMONIALS — overlapping cards editorial */
const TestimonialsSection = () => (
  <section style={{ background: '#f0f7f0', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
    <div className="playfair" style={{
      position: 'absolute', bottom: -60, right: -30,
      fontSize: 'clamp(180px,22vw,320px)',
      fontWeight: 900, color: 'rgba(34,197,94,0.05)',
      lineHeight: 1, pointerEvents: 'none', userSelect: 'none',
    }}>"</div>

    <div style={{ position: 'relative', zIndex: 1, maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
        <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#22c55e', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Témoignages</p>
        <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', fontWeight: 900, color: '#0e1a0e', lineHeight: 1.12 }}>
          Voix de nos <span style={{ fontStyle: 'italic', color: '#22c55e' }}>acteurs</span>
        </h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '1.5rem' }}>
        {[
          { name: 'Jean-Paul MWAMBA', role: 'Bénévole reboisement', text: 'Participer aux campagnes de reboisement m\'a appris à quel point chaque arbre planté compte pour notre avenir collectif.', Avatar: FaSeedling, color: '#22c55e' },
          { name: 'Marie NGOZI', role: 'Enseignante partenaire', text: 'Grâce aux programmes d\'éducation environnementale, mes élèves sont devenus de véritables ambassadeurs verts dans leurs quartiers.', Avatar: FaGraduationCap, color: '#06b6d4' },
          // { name: 'Christian KALINDA', role: 'Chef de quartier', text: 'Les actions d\'assainissement ont transformé notre quartier. L\'environnement plus propre a réduit les maladies et amélioré la vie quotidienne.', Avatar: FaHandshake, color: '#f59e0b' },
        ].map((t, i) => (
          <div key={t.name} className="testi-card" data-aos="fade-up" data-aos-delay={i * 80} style={{
            borderRadius: 20, background: '#fff',
            border: '1px solid rgba(0,0,0,0.05)',
            padding: '2rem',
            boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
            position: 'relative', overflow: 'hidden',
          }}>
            <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 4, background: t.color }} />
            {/* Large decorative quote */}
            <div className="playfair" style={{ fontSize: 80, color: t.color, opacity: 0.12, lineHeight: 0.8, marginBottom: '0.5rem', fontWeight: 900 }}>"</div>
            <p style={{ fontSize: 14, color: '#2d4a2d', lineHeight: 1.85, fontStyle: 'italic', marginBottom: '1.5rem' }}>{t.text}</p>
            <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', paddingTop: '1rem', borderTop: '1px solid rgba(0,0,0,0.05)' }}>
              <div style={{ width: 44, height: 44, borderRadius: '50%', background: `linear-gradient(135deg, ${t.color}40, ${t.color}80)`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{t.Avatar && <t.Avatar size={20} color='#fff' />}</div>
              <div>
                <p className="syne" style={{ fontSize: 13, fontWeight: 700, color: '#0e1a0e' }}>{t.name}</p>
                <p style={{ fontSize: 11, color: t.color, fontWeight: 500 }}>{t.role}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

/* CONTACT SECTION — split layout */
const ContactSection = () => (
  <section style={{ background: '#fff', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
    <div style={{ maxWidth: 1140, margin: '0 auto' }}>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1.6fr', gap: '4rem', alignItems: 'start' }} className="mission-grid">
        {/* Left info */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', marginBottom: '1rem' }}>
            <div style={{ width: 40, height: 3, background: '#22c55e', borderRadius: 2 }} />
            <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.18em', color: '#22c55e', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase' }}>Contact</span>
          </div>
          <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 900, color: '#0e1a0e', lineHeight: 1.1, marginBottom: '1.5rem' }}>
            Rejoignez<br />le <span style={{ fontStyle: 'italic', color: '#22c55e' }}>mouvement</span>
          </h2>
          <p style={{ fontSize: 14, color: '#5a7a5a', lineHeight: 1.85, marginBottom: '2rem' }}>
            Chaque voix compte. Rejoignez TUMAINI LETU et contribuez à bâtir un avenir durable pour nos communautés et notre planète.
          </p>
          {[
            { Icon: MdEmail, label: 'Email', val: 'info@tumainiletu.com' },
            { Icon: MdLocationOn, label: 'Localisation', val: 'République Démocratique du Congo' },
            { Icon: RiLeafLine, label: 'Mission', val: 'Protection de l\'environnement' },
          ].map(c => (
            <div key={c.label} style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start', marginBottom: '1rem' }}>
              <div style={{ width: 38, height: 38, borderRadius: 10, background: 'rgba(34,197,94,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{c.Icon && <c.Icon size={16} color='#22c55e' />}</div>
              <div>
                <p style={{ fontSize: 10, fontWeight: 700, letterSpacing: '0.1em', color: '#22c55e', fontFamily: 'Syne, sans-serif', textTransform: 'uppercase', marginBottom: '0.2rem' }}>{c.label}</p>
                <p style={{ fontSize: 13, color: '#2d4a2d' }}>{c.val}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Right form */}
        <div style={{
          background: '#f7fdf7', borderRadius: 24,
          border: '1px solid rgba(34,197,94,0.1)',
          padding: '2.5rem',
          boxShadow: '0 4px 40px rgba(34,197,94,0.06)',
        }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '0.75rem', marginBottom: '0.75rem' }}>
            {[{ ph: 'Nom complet', type: 'text' }, { ph: 'Adresse email', type: 'email' }].map(f => (
              <input key={f.ph} type={f.type} placeholder={f.ph} style={{
                padding: '0.9rem 1rem', borderRadius: 12,
                border: '1.5px solid rgba(34,197,94,0.15)',
                background: '#fff', fontSize: 14, color: '#0e1a0e',
                outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s',
              }}
                onFocus={e => e.target.style.borderColor = '#22c55e'}
                onBlur={e => e.target.style.borderColor = 'rgba(34,197,94,0.15)'}
              />
            ))}
          </div>
          <input type="tel" placeholder="Téléphone" style={{
            width: '100%', padding: '0.9rem 1rem', borderRadius: 12, marginBottom: '0.75rem',
            border: '1.5px solid rgba(34,197,94,0.15)',
            background: '#fff', fontSize: 14, color: '#0e1a0e',
            outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s', boxSizing: 'border-box',
          }}
            onFocus={e => e.target.style.borderColor = '#22c55e'}
            onBlur={e => e.target.style.borderColor = 'rgba(34,197,94,0.15)'}
          />
          <textarea rows={5} placeholder="Comment souhaitez-vous contribuer à notre mission écologique ?" style={{
            width: '100%', padding: '0.9rem 1rem', borderRadius: 12, marginBottom: '1.25rem',
            border: '1.5px solid rgba(34,197,94,0.15)',
            background: '#fff', fontSize: 14, color: '#0e1a0e', resize: 'none',
            outline: 'none', fontFamily: 'DM Sans, sans-serif', transition: 'border-color 0.2s', boxSizing: 'border-box',
          }}
            onFocus={e => e.target.style.borderColor = '#22c55e'}
            onBlur={e => e.target.style.borderColor = 'rgba(34,197,94,0.15)'}
          />
          <RippleButton style={{
            width: '100%', padding: '0.9rem', borderRadius: 12,
            background: 'linear-gradient(135deg, #16a34a, #22c55e)',
            color: '#fff', fontSize: 14, fontWeight: 700,
            fontFamily: 'Syne, sans-serif', letterSpacing: '0.04em',
          }}>
            Envoyer le message →
          </RippleButton>
        </div>
      </div>
    </div>
  </section>
);

/* FAQ SECTION — clean accordion */
const FaqSection = ({ openFaq, setOpenFaq }) => {
  const faqs = [
    { q: "Comment puis-je participer aux actions de reboisement ?", a: "Inscrivez-vous via notre formulaire de contact ou présentez-vous lors de nos journées communautaires annoncées sur nos réseaux sociaux." },
    { q: "Comment TUMAINI LETU lutte-t-elle contre le changement climatique ?", a: "Par des actions de reboisement, la promotion des énergies renouvelables, la sensibilisation des populations et le plaidoyer auprès des institutions locales." },
    { q: "Puis-je faire un don pour soutenir vos actions environnementales ?", a: "Oui, vous pouvez faire un don financier, matériel ou bénévole. Contactez-nous pour connaître les modalités." },
    { q: "Quels sont les projets environnementaux en cours ?", a: "Actuellement : reboisement de la forêt périurbaine, campagne de dépollution des rivières, et programme éducatif dans les écoles secondaires." },
    { q: "Comment les jeunes peuvent-ils s'impliquer ?", a: "Nous avons un club vert dans plusieurs écoles. Les jeunes peuvent rejoindre nos brigades environnementales et participer aux formations." },
  ];

  return (
    <section style={{ background: '#0d1f0d', padding: '6rem 1.5rem', position: 'relative', overflow: 'hidden' }} data-aos="fade-up">
      <div style={{ maxWidth: 780, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: '3.5rem' }}>
          <p style={{ fontSize: 11, fontWeight: 700, letterSpacing: '0.2em', color: '#4ade80', fontFamily: 'Syne, sans-serif', marginBottom: '0.75rem', textTransform: 'uppercase' }}>Questions fréquentes</p>
          <h2 className="playfair" style={{ fontSize: 'clamp(1.8rem, 4vw, 3rem)', color: '#fff', fontWeight: 900, lineHeight: 1.12 }}>
            On répond à<br /><span style={{ fontStyle: 'italic', color: '#4ade80' }}>vos questions</span>
          </h2>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          {faqs.map((item, i) => (
            <div key={i} className="faq-item" onClick={() => setOpenFaq(openFaq === i ? null : i)} style={{
              background: openFaq === i ? 'rgba(34,197,94,0.08)' : 'rgba(255,255,255,0.04)',
              borderRadius: 14,
              border: openFaq === i ? '1px solid rgba(34,197,94,0.25)' : '1px solid rgba(255,255,255,0.07)',
              cursor: 'pointer', overflow: 'hidden',
              transition: 'all 0.25s ease',
            }}>
              <div style={{ padding: '1.25rem 1.5rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '1rem' }}>
                <p className="syne" style={{ fontSize: 14, fontWeight: 700, color: openFaq === i ? '#4ade80' : '#e2f5e8', lineHeight: 1.5 }}>{item.q}</p>
                <div style={{
                  width: 32, height: 32, borderRadius: '50%', flexShrink: 0,
                  background: openFaq === i ? '#22c55e' : 'rgba(255,255,255,0.08)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontSize: 18, color: openFaq === i ? '#fff' : 'rgba(255,255,255,0.4)',
                  transition: 'all 0.3s',
                  transform: openFaq === i ? 'rotate(45deg)' : 'none',
                  fontWeight: 200,
                }}>+</div>
              </div>
              <div style={{ maxHeight: openFaq === i ? 200 : 0, overflow: 'hidden', transition: 'max-height 0.4s cubic-bezier(0.4,0,0.2,1)' }}>
                <p style={{ padding: '0 1.5rem 1.25rem', fontSize: 13, color: 'rgba(255,255,255,0.5)', lineHeight: 1.85 }}>{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

/* SUPPORT STRIP */
const SupportStrip = () => (
  <section style={{ background: '#f0f7f0', padding: '4rem 1.5rem' }} data-aos="fade-up">
    <div style={{
      maxWidth: 700, margin: '0 auto', textAlign: 'center',
      background: '#fff', borderRadius: 20, padding: '3rem 2rem',
      border: '1px solid rgba(34,197,94,0.1)',
      boxShadow: '0 4px 32px rgba(34,197,94,0.07)',
    }}>
      <div style={{ marginBottom: '1rem' }}><FaSeedling size={40} color='#22c55e' /></div>
      <h2 className="playfair" style={{ fontSize: 'clamp(1.4rem, 3vw, 2rem)', fontWeight: 900, color: '#0e1a0e', marginBottom: '0.75rem' }}>
        Besoin d'informations ?
      </h2>
      <p style={{ fontSize: 14, color: '#5a7a5a', marginBottom: '1.75rem', lineHeight: 1.75, maxWidth: 420, margin: '0 auto 1.75rem' }}>
        Contactez notre équipe environnement pour tout renseignement ou partenariat. Nous répondons sous 48h.
      </p>
      <RippleButton
        style={{ padding: '0.85rem 2rem', borderRadius: 12, background: '#22c55e', color: '#fff', fontSize: 14, fontWeight: 700, fontFamily: 'Syne, sans-serif', letterSpacing: '0.04em' }}
        onClick={() => window.location.href = "mailto:info@tumainiletu.com?subject=Question%20Environnement"}
      >Contacter l'équipe →</RippleButton>
    </div>
  </section>
);

/* ============================================================
   MAIN ENVIRONMENT PAGE
   ============================================================ */
const Environnement = () => {
  const [loading, setLoading] = useState(true);
  const [openFaq, setOpenFaq] = useState(null);
  const [activeTab, setActiveTab] = useState('mission');

  useEffect(() => {
    AOS.init({ duration: 800, once: true, offset: 60 });
    const t = setTimeout(() => setLoading(false), 1400);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ fontFamily: 'DM Sans, sans-serif', background: '#f0f7f0', color: '#0e1a0e', overflowX: 'hidden' }}>
      <GlobalStyles />
      <PageLoader loading={loading} />
      <Navbar />
      <Hero video={bgVideo} />

      {/* ── NEW REDESIGNED SECTIONS ── */}
      <IntroStrip />
      <MissionSection activeTab={activeTab} setActiveTab={setActiveTab} />
      <DomainsSection />
      <ActionsSection />
      <WhySection />
      <ActorsSection />
      <TestimonialsSection />
      <ContactSection />
      <FaqSection openFaq={openFaq} setOpenFaq={setOpenFaq} />
      <SupportStrip />

      <Footer />
    </div>
  );
};

export default Environnement;
